import React from 'react';

import './main.css';

export const Main = (props) => {
	const { children } = props;
	const styles = props.styles ?? [];
	return (
		<main className='main'>
			<div className={`main-flex${styles.reduce((prev, curr) => prev + ' ' + curr, '')}`}>
				{children}
			</div>
		</main>
	);
};

export const MainContent = ({children}) => {
	return (
		<div className='main-content'>
			{children}
		</div>
	);
};

export const MainSide = (props) => {
	const { children } = props;
	const styles = props.styles ?? ['sticky', 'singular', 'meta'];
	return (
		<div className={`main-side${styles.reduce((prev, curr) => prev + ' ' + curr, '')}`}>
			{children}
		</div>
	);
};
